import React from 'react';
import {Content} from './Content';
import PropTypes from 'prop-types';
import {Feedback} from './Feedback';
import {MainHeader} from './MainHeader';
import {Footer, Submit, Reset} from '../Footer';
import {GelDragDrop} from '@learningblocks/storybook-components';
import './style.scss';

export function GelDragDropQuestion(props) {
  return (
    <div className='geldragdropquestion'>
      <MainHeader
        heading={props.heading}
        text={props.text}
        getContentData={props.getContentData}
        openGlossary={props.openGlossary}
      />
      <Content>
        <GelDragDrop
          theme={props.gelTheme}
          title={props.gelTitle}
          style={props.getlStyle}
          gelRange={props.gelRange}
          gelTable={props.gelTable}
          onGelUpdate={props.onGelUpdate}
          onGelSelect={props.onGelSelect}
          altText={props.altText}
        />
      </Content>
      <Feedback type={props.feedbackType} onClose={props.closeFeedback} />
      <Footer>
        <Reset onReset={props.onReset} disabled={false}>
          Reset gel
        </Reset>
        <Submit onSubmit={props.onSubmit} disabled={!props.enableSubmit}>
          Submit
        </Submit>
      </Footer>
    </div>
  );
}

GelDragDropQuestion.propTypes = {
  /**
   * Unique Id for the component
   */
  id: PropTypes.number,
  /**
   * Main heading for the quetion
   */
  heading: PropTypes.string,
  /**
   * Detailed description for the question
   */
  text: PropTypes.string,
  /**
   * Function to invoke when submit button is clicked
   */
  onSubmit: PropTypes.func,
  /**
   * Function to invoke when clicking on reset button
   */
  onReset: PropTypes.func,
  /**
   * Boolean to set submit button enable/disable
   */
  enableSubmit: PropTypes.bool,
  /**
   * Type of feedback to show ['SUCCESS','FAIL', null]; if null no feedback is displayed
   */
  feedbackType: null || PropTypes.oneOf(['SUCCESS', 'FAIL']),
  /**
   * function to invoke when close feedback button clicked
   */
  closeFeedback: PropTypes.func,
  /**
   * Title to be displayed on top of GelDragDrop Component
   */
  gelTitle: PropTypes.string,
  /**
   * The bottom and top limit values of the gel slide
   */
  gelRange: PropTypes.shape({
    /**
     * The lower limit of range
     */
    bottom: PropTypes.number,
    /**
     * The upper limit of range
     */
    top: PropTypes.number,
  }),
  /**
   * Data needed to render the GelTable
   */
  gelTable: PropTypes.arrayOf(PropTypes.object),
  /**
   *  Function to invoke on Gel position update
   */
  onGelUpdate: PropTypes.func,
  /**
   * Function to invoke when a Gel band is clicked to select it
   */
  onGelSelect: PropTypes.func,
  /**
   * Style object to set on application wrapper
   */
  getlStyle: PropTypes.object,
  /**
   * Theme for the component
   */
  gelTheme: PropTypes.oneOf(['LIGHT', 'DARK']),
};

GelDragDropQuestion.defaultProps = {
  gelTitle: 'Drag the results you predict into each lane',
  gelTheme: 'LIGHT',
  getlStyle: {},
};
